import React from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import { RoutePaths } from './RoutePaths';


const CustomRouter = () => {

    return (

        <Router>
            <Routes >
                {
                    RoutePaths.map((route, index) =>
                        <Route key={route.path} path={route.path} element={route.element} />
                    )
                }
            </Routes>
        </Router>
    );
}

export default CustomRouter;